import { ReactNode } from "react";
import classnames from "classnames";
import { KeyValue } from "../../lib/keyboard";
import { CharStatus } from "../../lib/statuses";

type Props = {
  children?: ReactNode;
  value: KeyValue;
  width?: number;
  status?: CharStatus;
  onClick: (value: KeyValue) => void;
};

export const Key = ({
  children,
  status,
  width = 40,
  value,
  onClick,
}: Props) => {
  const classes = classnames(
    "flex items-center justify-center rounded mx-0.5 text-base font-bold cursor-pointer select-none",
    {
      "bg-slate-200 dark:text-white dark:bg-slate-600 dark:hover:bg-slate-700 hover:bg-slate-300 active:bg-slate-400": !status,
      "bg-slate-400 dark:bg-slate-800 text-white": status === "absent",
      "bg-green-500 dark:bg-green-600 dark:hover:bg-green-700 hover:bg-green-600 active:bg-green-700 text-white":
        status === "correct",
      "bg-yellow-500 dark:bg-yellow-600 dark:hover:bg-yellow-700 hover:bg-yellow-600 active:bg-yellow-700 text-white":
        status === "present",
    }
  );

  return (
    <button
      style={{ width: `${width}px`, height: "48px" }}
      className={classes}
      onClick={() => onClick(value)}
    >
      {children || value}
    </button>
  );
};
